import { Reveal, SectionHeading } from "./Reveal";

export default function Groomers({ groomers }) {
  if (!groomers.length) return null;
  return (
    <section id="groomers" data-testid="groomers-section" className="bg-white py-14 lg:py-20">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          kicker="Meet Our Groomers"
          title="Meet the team."
          description="Get to know the people caring for your dog."
        />
        <div className="mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-4" data-testid="groomers-grid">
          {groomers.map((g, i) => (
            <Reveal key={g.id || g.name} delay={0.1 * i}>
              <article className="group" data-testid={`groomer-card-${g.id || i}`}>
                <div className="relative overflow-hidden rounded-lg">
                  <div className="absolute -inset-1.5 rounded-lg bg-lavender-100 transition-colors duration-500 group-hover:bg-lavender-200" />
                  <img
                    src={g.imageUrl}
                    alt={`${g.name}, ${g.role} at Pawtastic Cuts`}
                    loading="lazy"
                    className="relative aspect-[4/5] w-full rounded-lg object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                  />
                </div>
                <h3 data-testid={`groomer-name-${g.id || i}`} className="mt-6 text-xl font-bold text-stone-900">{g.name}</h3>
                <p data-testid={`groomer-role-${g.id || i}`} className="mt-1 text-sm font-medium text-lavender-700">{g.role}</p>
                <p data-testid={`groomer-bio-${g.id || i}`} className="mt-3 text-sm leading-relaxed text-stone-600">{g.bio}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
